import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "image-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-container" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "about-project" }
const _hoisted_9 = { class: "content-grid" }
const _hoisted_10 = { class: "text-block" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "architecture-details" }
const _hoisted_14 = { class: "tech-grid" }
const _hoisted_15 = { class: "tech-card" }
const _hoisted_16 = { class: "feature-list" }
const _hoisted_17 = { class: "feature-item" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "feature-item" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "feature-item" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "tech-card" }
const _hoisted_24 = { class: "feature-list" }
const _hoisted_25 = { class: "feature-item" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "feature-item" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "feature-item" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "visuals-section" }
const _hoisted_32 = { class: "visuals-grid" }
const _hoisted_33 = { class: "visual-card" }
const _hoisted_34 = { class: "image-wrapper" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "visual-card" }
const _hoisted_37 = { class: "image-wrapper" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "technical-details" }
const _hoisted_40 = { class: "competencies-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfraCompetencyCard = _resolveComponent("InfraCompetencyCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/image/pikuTradeLogo.png'),
            alt: "Logo PikuTrade",
            class: "header-image",
            loading: "lazy"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('pikutrade.title')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('pikutrade.subtitle')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('pikutrade.aboutTitle')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('pikutrade.about1')
          }, null, 8, _hoisted_11),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('pikutrade.about2')
          }, null, 8, _hoisted_12)
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"highlight-box\" data-v-eb615f60><div class=\"stat-item\" data-v-eb615f60><span class=\"mdi mdi-chart-line stat-icon\" data-v-eb615f60></span><span class=\"stat-text\" data-v-eb615f60>Real-Time Trading</span></div><div class=\"stat-item\" data-v-eb615f60><span class=\"mdi mdi-robot-outline stat-icon\" data-v-eb615f60></span><span class=\"stat-text\" data-v-eb615f60>AI Powered Analysis</span></div><div class=\"stat-item\" data-v-eb615f60><span class=\"mdi mdi-lightning-bolt-outline stat-icon\" data-v-eb615f60></span><span class=\"stat-text\" data-v-eb615f60>Async API Batching</span></div></div>", 1))
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Architecture & Composants", -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tech-header" }, [
            _createElementVNode("span", { class: "mdi mdi-cog-outline tech-icon" }),
            _createElementVNode("h4", null, "API Backend (Spring Boot)")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mdi mdi-package-variant-closed feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('pikutrade.api1')
              }, null, 8, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mdi mdi-brain feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('pikutrade.api2')
              }, null, 8, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mdi mdi-trending-up feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('pikutrade.api3')
              }, null, 8, _hoisted_22)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "tech-header" }, [
            _createElementVNode("span", { class: "mdi mdi-palette-outline tech-icon" }),
            _createElementVNode("h4", null, "Frontend (Vue.js)")
          ], -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mdi mdi-chart-bell-curve-cumulative feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('pikutrade.frontend1')
              }, null, 8, _hoisted_26)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mdi mdi-swap-horizontal feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('pikutrade.frontend2')
              }, null, 8, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mdi mdi-view-dashboard-outline feature-icon" }, null, -1)),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('pikutrade.frontend3')
              }, null, 8, _hoisted_30)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_31, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", null, "Aperçus du Projet", -1)),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pikutrade.apiIllustration')), 1),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("img", {
              src: require('@/assets/image/api-endpoints.png'),
              alt: "Exemples de requêtes API",
              class: "doc-image",
              loading: "lazy"
            }, null, 8, _hoisted_35)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pikutrade.chartTitle')), 1),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("img", {
              src: require('@/assets/image/realtime-chart.png'),
              alt: "Graphique en temps réel",
              class: "doc-image",
              loading: "lazy"
            }, null, 8, _hoisted_38)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_39, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('pikutrade.learningsTitle')), 1),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-cube-outline",
          title: "Architecture SOLID",
          description: _ctx.$t('pikutrade.learning1')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-clock-fast",
          title: "Asynchronisme Java",
          description: _ctx.$t('pikutrade.learning2')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-webpack",
          title: "WebSockets & Temps Réel",
          description: _ctx.$t('pikutrade.learning3')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-robot-outline",
          title: "Intégration IA",
          description: _ctx.$t('pikutrade.learning4')
        }, null, 8, ["description"])
      ])
    ])
  ]))
}